"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isModuleCorrect_1 = __importDefault(require("../utils/isModuleCorrect"));
function updateModulesIncorrect({ modulesIncorrect, courseId }, sessionEvent) {
    const { modules } = sessionEvent;
    return (modulesIncorrect +
        modules.filter(module => module.courseId === courseId &&
            module.testingActive &&
            !(0, isModuleCorrect_1.default)(module)).length);
}
exports.default = updateModulesIncorrect;
